'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EditorToolbar = require('./components/EditorToolbar.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditorToolbar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/editor-toolbar/index.js
// module id = 1296
// module chunks = 0